module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_vestfold_telemark_neg.53f7f1b5.png";